import { Card, CardContent } from "@mui/material";
import { useState } from "react";
import DropDownIcon from "../../Icons/DropDownIcon";

const SurveySingleSelectChoices = ({ selections, question, selectChoice, themeColors }) => {
    const [showOptions, setShowOptions] = useState(false);

    function onSelection(choice) {
        setShowOptions(false);
        if (selections && !selections[question.id]) {
            selectChoice(choice, question.id);
        } else {
            if (
                selections &&
                selections[question.id] &&
                selections[question.id][choice.id] &&
                selections[question.id][choice.id].label == choice.label
            ) {
                selectChoice({}, question.id);
            } else {
                selectChoice(choice, question.id);
            }
        }
    }

    function toggleOption() {
        if (showOptions) {
            setShowOptions(false);
        } else {
            setShowOptions(true);
        }
    }

    return (
        <Card variant="outlined" className="border-none pl-0">
            <CardContent className="p-0">
                <div className="border border-slate-300 rounded-lg max-w-[500px] relative">
                    <div
                        onClick={toggleOption}
                        className="pb-3 p-3 flex justify-between items-center cursor-pointer select-none text-[#3D4A5C]"
                    >
                        <div className="text-[13.91px]">
                            {(selections &&
                                selections[question.id] &&
                                Object.values(selections[question.id])[0].label) ||
                                "Select"}
                        </div>

                        <DropDownIcon className="text-lg"></DropDownIcon>
                    </div>
                    {showOptions ? (
                        <div className="border-t border-slate-200  select-none max-h-[300px] overflow-y-auto">
                            {question.choices.map((choice, i) => (
                                <div
                                    style={{
                                        background:
                                            selections &&
                                            selections[question.id] &&
                                            selections[question.id][choice.id] &&
                                            selections[question.id][choice.id].label == choice.label
                                                ? themeColors.secondaryColor + "33"
                                                : "",
                                    }}
                                    onClick={() => onSelection(choice)}
                                    key={i}
                                    className="p-3 hover:bg-slate-300 text-[11.91px] md:text-base cursor-pointer text-[#3D4A5C] font-medium"
                                >
                                    {choice.label}
                                </div>
                            ))}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default SurveySingleSelectChoices;
